module.exports = __webpack_public_path__ + "img/portada.8f0752e3.webp";